/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menueditorremoveitem3Inputs */

const en_menueditorremoveitem3 = /** @type {(inputs: Menueditorremoveitem3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

const de_menueditorremoveitem3 = /** @type {(inputs: Menueditorremoveitem3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernen`)
};

/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Menueditorremoveitem3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorremoveitem3 = /** @type {((inputs: Menueditorremoveitem3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorremoveitem3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorremoveitem3(inputs)
	return de_menueditorremoveitem3(inputs)
});
export { menueditorremoveitem3 as "menuEditorRemoveItem" }